import $ from "jquery";
import View from '../../../controls/View.js';
import Vue from 'vue';
import CampaignReportPage from './CampaignsReportPage.vue';

/** @class CampaignsReportPage */
const CampaignsReportPage = View.extend(
/** @lends CampaignsReportPage.prototype */
    {

        className: 'main-body',

        /** @constructs */
        initialize: function () {

            $('<div id="vue-app">').appendTo(this.$el);

            this.vueApp = new Vue({render: (h) => h(CampaignReportPage)}); // Required for hot reload

            setTimeout(() => {
                this.vueApp.$mount('#vue-app');
            }, 0);

            return this;

        },

        remove: function () {

            this.vueApp.$destroy();
            this.constructor.__super__.remove.apply(this, arguments);
        }

    }
);

export default CampaignsReportPage